import React, { useState } from "react";
import { styled } from "@mui/material/styles";

import useInterval from "@hooks/useInterval";
import useShopContext from "@hooks/useShopContext";
import { formatTimePercentage, normalizeTime } from "@common/utils/productListUtils";
import { getDarkerColor } from "@common/utils/colors";

const pulseKeyframes = {
  "0%": {
    boxShadow: `0 0 0 0 rgba(180, 0, 0, 0.9)`,
  },
  "25%": {
    boxShadow: `0 0 0 8px rgba(180, 0, 0, 0)`,
  },
  "50%": {
    boxShadow: `0 0 0 8px rgba(180, 0, 0, 0)`,
  },
  "60%": {
    boxShadow: `0 0 0 0 rgba(180, 0, 0, 0)`,
  },
  "100%": {
    boxShadow: `0 0 0 0 rgba(180, 0, 0, 0)`,
  },
};

const Root = styled("div")(({ theme, percentage, accent }) => ({
  "@keyframes pulse": pulseKeyframes,
  width: 15,
  height: 15,
  borderRadius: "50%",
  background: `conic-gradient(${theme.palette.grey[300]} 0% ${percentage}%, ${accent} 0% 100%)`,
  animation: `pulse 4s infinite`,
  boxShadow: "0 0 0 0 rgba(180, 0, 0, 1)",
  [theme.breakpoints.down("sm")]: {
    width: 13,
    height: 13,
  },
}));

const TimeRemainingPie = ({ product }) => {
  const { shop } = useShopContext();

  const startTime = new Date(product && product.available_start_time);
  const endTime = new Date(product && product.available_end_time);

  const getTimePercentage = () => {
    const currentTime = new Date();
    const normalizedTime = normalizeTime(
      currentTime.getTime(),
      startTime.getTime(),
      endTime.getTime(),
    );
    return formatTimePercentage(normalizedTime);
  };

  const [timePercentage, setTimePercentage] = useState(product && getTimePercentage());
  const darkerColor = shop && getDarkerColor(shop.background_color, shop.accent_color);

  useInterval(() => {
    setTimePercentage(getTimePercentage());
    // call every 5s
  }, 5000);

  return <Root percentage={timePercentage} accent={darkerColor}></Root>;
};

export default TimeRemainingPie;
